import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-filters',
  template: '<ng-content select="app-filter"></ng-content>',
  styleUrls: ['./filter.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-filters' },
})
export class FiltersComponent {}

@Component({
  selector: 'app-filter',
  template: `
    <div class="app-filter-text"><ng-content></ng-content></div>
    <div class="app-filter-count">{{ count }}</div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-filter',
    '[class.app-filter-active]': 'active',
  },
})
export class FilterComponent {
  @Input() active: boolean;
  @Input() count: number;
}
